/**
 * The pages the terms checkbox links to (D7).
 *
 * Both are routes of this app rather than a PDF somewhere: they open in a new
 * tab from the sign-up card and have to be readable while signed out, so they
 * sit outside the account layout and the onboarding gate (`main.tsx`).
 */

export const TERMS_PATH = '/terms';
export const PRIVACY_PATH = '/privacy';

export const TERMS_URL = TERMS_PATH;
export const PRIVACY_URL = PRIVACY_PATH;
